import { useSeo } from "../lib/seo";
import { VERTICALS } from "../data/content";
import { Container, Btn, CheckList } from "../components/site/Ui";
import { Reveal } from "../components/site/Motion";
import { PageHero, CtaBand } from "../components/site/Blocks";

export default function Verticals() {
  useSeo("Verticals", "AppTarget runs performance campaigns across Finance & Fintech, Gaming, E-commerce, Mobile Applications, Utilities and Lifestyle.", "/verticals");
  return (
    <>
      <PageHero eyebrow="Verticals" lines={["Industry focus,", "performance first."]} testid="verticals-hero"
        text="Each industry acquires customers differently. We shape campaign models, partners and creatives around the way your vertical works." />
      {VERTICALS.map((v, i) => (
        <section key={v.slug} id={v.slug} data-testid={`vertical-${v.slug}`} className={`scroll-mt-24 py-16 lg:py-24 ${i % 2 ? "bg-white" : "bg-[#F4F7FB]"}`}>
          <Container className="grid items-center gap-10 md:grid-cols-2 lg:gap-16">
            <Reveal className={`${i % 2 ? "md:order-2" : ""}`}>
              <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white">
                <img src={v.img} alt={`${v.title} illustration`} loading="lazy" width="640" height="640" className="aspect-square w-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <span className="font-display text-sm font-bold text-[#2878E5]">0{i + 1}</span>
              <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#102B50] sm:text-4xl">{v.title}</h2>
              <p className="mt-4 text-base leading-relaxed text-[#4A5D78] md:text-lg">{v.text}</p>
              <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-[#102B50]">Typical campaign formats</h3>
              <div className="mt-4"><CheckList items={v.formats} /></div>
              <div className="mt-8 flex flex-wrap gap-3">
                <Btn to="/advertisers" data-testid={`vertical-cta-${v.slug}`}>Launch a Campaign</Btn>
                <Btn to="/publishers" variant="outline" arrow={false}>Promote Offers</Btn>
              </div>
            </Reveal>
          </Container>
        </section>
      ))}
      <CtaBand />
    </>
  );
}
